<template>
  <v-row>
    <!-- Получение лицензий: появилась дата обучения либо после оплаты осталось
         выбрать дату (правка начальника 02.10.2026). Состояние — из хранилища,
         его обновляют раскладка кабинета и страница «Получение лицензий». -->
    <v-col
      v-if="obtainingNotice"
      xs="12"
      sm="12"
      md="12"
      lg="10"
      cols="12"
    >
      <v-alert
        border="left"
        color="success"
        text
        class="mb-0"
      >
        <div
          class="d-flex flex-wrap align-center"
          style="gap: 8px"
        >
          <span>{{ obtainingNotice }}</span>
          <v-btn
            color="success"
            small
            class="ms-auto"
            :to="{ name: 'license-obtaining' }"
          >
            {{ $t('Перейти') }}
          </v-btn>
        </div>
      </v-alert>
    </v-col>
    <!-- Крутилка — только пока данных ещё нет. Когда список уже загружен,
         обновление идёт фоном и страница не мигает. -->
    <v-col
      v-if="upcomingRequestIsSuccess === null"
      xs="12"
      sm="12"
      md="12"
      lg="10"
      cols="12"
    >
      <loader></loader>
    </v-col>
    <!-- Раньше при сбое загрузки крутилка висела вечно: система заявок молчит —
         клиент сидит и смотрит на неё. Теперь пишем, что случилось. -->
    <v-col
      v-if="upcomingRequestIsSuccess === false"
      xs="12"
      sm="12"
      md="12"
      lg="10"
      cols="12"
    >
      <v-alert
        border="left"
        color="error"
        text
      >
        {{ $t('Не удалось получить список заявок — система заявок не ответила. Обновите страницу через минуту.') }}
      </v-alert>
    </v-col>
    <!-- new request panel -->
    <ServiceSelector v-if="upcomingRequestIsSuccess"></ServiceSelector>
    <!-- upcoming orders empty -->
    <v-col
      v-if="upcomingRequestIsSuccess && upcomingList.length == 0"
      xs="12"
      sm="12"
      md="12"
      lg="11"
      cols="12"
    >
      <h2 class="secondary--text mt-4 mb-8">
        {{ $t("Нет предстоящих заказов") }}
      </h2>
    </v-col>
    <!-- Фильтры: по дате визита и по количеству человек.
         Обёрнуты в свою строку — так же, как карточки заявок ниже: иначе панель
         оказывалась в другой сетке и не совпадала с ними по ширине. -->
    <v-row
      v-if="upcomingRequestIsSuccess && upcomingList.length > 0"
      style="width: 100%"
    >
      <v-col
        xs="12"
        sm="12"
        md="12"
        lg="11"
        cols="12"
      >
        <v-card
          outlined
          class="pa-4 mb-2"
        >
          <v-row dense>
            <v-col
              cols="6"
              sm="3"
            >
              <v-menu
                v-model="dateFromMenu"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    :value="formatDay(dateFrom)"
                    :label="$t('Дата с')"
                    readonly
                    outlined
                    dense
                    hide-details
                    clearable
                    v-bind="attrs"
                    v-on="on"
                    @click:clear="dateFrom = null"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="dateFrom"
                  no-title
                  color="primary"
                  first-day-of-week="1"
                  :locale="datePickerLocale"
                  @input="dateFromMenu = false"
                ></v-date-picker>
              </v-menu>
            </v-col>
            <v-col
              cols="6"
              sm="3"
            >
              <v-menu
                v-model="dateToMenu"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    :value="formatDay(dateTo)"
                    :label="$t('Дата по')"
                    readonly
                    outlined
                    dense
                    hide-details
                    clearable
                    v-bind="attrs"
                    v-on="on"
                    @click:clear="dateTo = null"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="dateTo"
                  no-title
                  color="primary"
                  first-day-of-week="1"
                  :locale="datePickerLocale"
                  @input="dateToMenu = false"
                ></v-date-picker>
              </v-menu>
            </v-col>
            <v-col
              cols="6"
              sm="3"
            >
              <!-- Без крестика очистки: он вставал поверх стрелок счётчика, и
                 попасть по ним мышкой было невозможно. Поле и так очищается
                 стиранием, плюс есть кнопка «Сбросить фильтры». -->
              <v-text-field
                v-model="peopleFrom"
                v-non-negative
                type="number"
                min="0"
                :label="$t('Человек от')"
                outlined
                dense
                hide-details
              ></v-text-field>
            </v-col>
            <v-col
              cols="6"
              sm="3"
            >
              <v-text-field
                v-model="peopleTo"
                v-non-negative
                type="number"
                min="0"
                :label="$t('Человек до')"
                outlined
                dense
                hide-details
              ></v-text-field>
            </v-col>
          </v-row>
          <!-- Строка со счётчиком видна всегда, а кнопка сброса проявляется
               плавно: раньше весь блок появлялся по v-if, высота панели скакала
               и страница дёргалась вниз при первом же введённом символе. -->
          <div
            class="mt-3 d-flex align-center flex-wrap"
            style="gap: 12px; min-height: 30px"
          >
            <v-checkbox
              v-model="groupOnly"
              dense
              hide-details
              class="mt-0 pt-0"
              :label="$t('Только групповые')"
            ></v-checkbox>
            <v-spacer></v-spacer>
            <span class="text-sm text--secondary">
              {{ $t('Найдено заявок') }}: {{ filteredRequests.length }}
            </span>
            <v-fade-transition>
              <v-btn
                v-if="hasFilters"
                text
                small
                color="primary"
                @click="resetFilters"
              >
                {{ $t('Сбросить фильтры') }}
              </v-btn>
            </v-fade-transition>
          </div>
        </v-card>
      </v-col>
    </v-row>

    <!-- по фильтрам ничего не нашлось -->
    <v-row
      v-if="upcomingRequestIsSuccess && upcomingList.length > 0 && filteredRequests.length === 0"
      style="width: 100%"
    >
      <v-col
        xs="12"
        sm="12"
        md="12"
        lg="11"
        cols="12"
      >
        <h2 class="secondary--text mt-4 mb-8">
          {{ $t("По выбранным фильтрам заказов нет") }}
        </h2>
      </v-col>
    </v-row>

    <!-- upcoming orders not empty -->
    <v-row
      v-if="upcomingRequestIsSuccess && filteredRequests.length > 0"
      style="width: 100%"
    >
      <v-col
        v-for="request in combinedList()"
        :key="request.id"
        xs="12"
        sm="12"
        md="12"
        lg="11"
        cols="12"
      >
        <OrderSchedule
          v-if="request.type !== 'ad' &&
            museumObjectsInfo[request.data.museum_id] &&
            !(
              museumObjectsInfo[request.data.museum_id]['is_radioguide_request'] ||
              museumObjectsInfo[request.data.museum_id]['is_audioguide_request']
            ) && (request.info.museum_schedule_item.includes('График'))
          "
          :key="request.id"
          :order="request"
          :disable-actions="[]"
          :object-info="museumObjectsInfo[request.data.museum_id]"
        ></OrderSchedule>
        <Order
          v-if="request.type !== 'ad' &&
            museumObjectsInfo[request.data.museum_id] &&
            !(
              museumObjectsInfo[request.data.museum_id]['is_radioguide_request'] ||
              museumObjectsInfo[request.data.museum_id]['is_audioguide_request']
            ) && !(request.info.museum_schedule_item.includes('График'))
          "
          :key="request.id"
          :order="request"
          :disable-actions="[]"
          :object-info="museumObjectsInfo[request.data.museum_id]"
          :active-group-key="activeGroupKey"
          @group-click="onGroupClick"
        ></Order>
        <OrderRgAg
          v-if=" request.type !== 'ad' &&
            museumObjectsInfo[request.data.museum_id] &&
            ( museumObjectsInfo[request.data.museum_id]['is_radioguide_request'] ||
              museumObjectsInfo[request.data.museum_id]['is_audioguide_request'])
          "
          :key="request.id"
          :order="request"
          :disable-actions="[]"
          :object-info="museumObjectsInfo[request.data.museum_id]"
          :active-group-key="activeGroupKey"
          @group-click="onGroupClick"
        ></OrderRgAg>
        <Ad
          v-if="request.type === 'ad' && request.is_active"
          :key="request.id"
          :ad="request"
        >
        </Ad>
      </v-col>
    </v-row>
    <!-- <v-dialog
      v-model="isDialogOpen"
      max-width="600px"
    >
      <v-card class="user-edit-info pa-sm-10 pa-3">
        <v-card-title
          class="justify-center text-center text-h5 no-wrap"
          style="line-height: 1.1em;"
        >
          <p>{{ loginNotification.title }}</p>
        </v-card-title>
        <v-img
          v-if="loginNotification.image"
          :src="loginNotification.image"
          class="mb-6 mt-4"
        ></v-img>
        <v-card-text class="justify-center text-center mt-2 text-base">
          {{ loginNotification.content_paragraph_1 }}
        </v-card-text>
        <v-card-text class="justify-center text-center mt-2 text-base">
          {{ loginNotification.content_paragraph_2 }}
        </v-card-text>

        <v-card-text class="mt-5">
          <v-form class="multi-col-validation">
            <v-row>
              <v-col
                cols="12"
                class="d-flex flex-wrap justify-end mt-3"
                style="gap: 8px"
              >
                <v-btn
                  color="default"
                  dark
                  @click="closeDialog"
                >
                  {{ $t("Закрыть") }}
                </v-btn>
                <v-btn
                  v-if="loginNotification.add_close_button"
                  color="primary"
                  dark
                  target="_blank"
                  :href="`${loginNotification.button_link}`"
                >
                  {{ loginNotification.button_text }}
                </v-btn>
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>
      </v-card>
    </v-dialog> -->

    <!-- Оценка кабинета: показываем один раз, сразу после отправки заявки. -->
    <feedback-dialog v-model="showFeedback"></feedback-dialog>

    <!-- модалка с последней новостью при входе -->
    <v-dialog
      v-model="isNewsModalOpen"
      max-width="600px"
      scrollable
    >
      <!-- Текст выровнен по левому краю, а не по центру: с центровкой строки
           рвались криво и читать было тяжело. Окно прокручиваемое, кнопки
           вынесены в подвал карточки — на телефоне длинная новость раньше
           выдавливала их за край экрана. -->
      <v-card
        v-if="latestNews"
        class="user-edit-info"
      >
        <v-card-title
          class="text-h6 text-left"
          style="line-height: 1.25em; word-break: normal;"
        >
          {{ latestNews.title }}
        </v-card-title>
        <v-card-text class="text-left text-base pt-2">
          <v-img
            v-if="latestNews.image"
            :src="latestNews.image"
            class="mb-4"
          ></v-img>
          <div
            v-html="replaceBreak(latestNews['content' + getFormatedLocale()] || latestNews.content)"
          ></div>
        </v-card-text>
        <v-divider></v-divider>
        <!-- Кнопки действий держим справа — единое правило по кабинету. -->
        <v-card-actions
          class="flex-wrap justify-end pa-4"
          style="gap: 8px"
        >
          <v-btn
            color="secondary"
            outlined
            @click="dismissNewsModal"
          >
            {{ $t("Не показывать при следующем заходе") }}
          </v-btn>
          <v-btn
            color="primary"
            dark
            @click="closeNewsModal"
          >
            {{ $t("Скрыть") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import Ad from "@/components/Ad.vue"
import Loader from "@/components/Loader.vue"
import Order from "@/components/Order.vue"
import OrderRgAg from "@/components/OrderRgAg.vue"
import OrderSchedule from "@/components/OrderSchedule.vue"
import ServiceSelector from "@/components/ServiceSelector.vue"
import store from "@/store"
import { computed, onMounted, ref } from "@vue/composition-api"
import { replaceBreak } from "@core/utils/filter"
import { getQtyTotal, groupKeyOf, isGroupNotes } from "@/utils/helper"
import FeedbackDialog from "@/components/FeedbackDialog.vue"

export default {
  components: {
    FeedbackDialog,
    Loader,
    Order,
    OrderSchedule,
    OrderRgAg,
    Ad,
    ServiceSelector,
  },
  setup(props, context) {
    const isDialogOpen = ref(true)
    const loginNotification = ref({})
    const fetchAds = () => {
      store.dispatch("ads/fetchAds")
    }
    const fetchNotification = () => {
      store.dispatch("news/fetchNotification").then(data => {
        if (data.length > 0) {
          [loginNotification.value] = data
          isDialogOpen.value = true
        }
      })
    }
    const fetchUpcoming = () => {
      store.dispatch("upcoming/fetchUpcoming")
    }
    fetchAds()
    fetchNotification()
    fetchUpcoming()
    const closeDialog = () => {
      isDialogOpen.value = false
    }

    // Модалка с последней новостью при входе. Показывать или нет — решает СЕРВЕР:
    // до 3 показов, пока новость не прочитана (колокольчик/страница новостей)
    // и не скрыта кнопкой «Не показывать при следующем заходе».
    const isNewsModalOpen = ref(false)
    const latestNews = ref(null)

    const getFormatedLocale = () => {
      const locale = localStorage.getItem("locale") || "ru"
      if (locale === "zh") return "_zh_cn"
      if (locale === "en") return "_en_US"
      if (locale === "fa") return "_fa_IR"
      if (locale === "vi") return "_vi"

      return "_ru_RU"
    }

    const fetchLatestNewsModal = () => {
      if (!context.root.$route.query.fromAuth) return
      store.dispatch("news/checkNewsModal").then(info => {
        if (!info.show) return
        store.dispatch("news/fetchNews").then(response => {
          const list = response.data || []
          if (list.length === 0) return
          const [latest] = list
          latestNews.value = latest
          isNewsModalOpen.value = true
        })
      })
    }
    fetchLatestNewsModal()

    // «Скрыть» / Esc / клик мимо: показ уже засчитан сервером — при следующем входе
    // новость появится снова, пока не исчерпаны 3 показа и она не прочитана.
    const closeNewsModal = () => {
      isNewsModalOpen.value = false
    }

    // «Не показывать при следующем заходе» — гасим эту новость навсегда.
    const dismissNewsModal = () => {
      isNewsModalOpen.value = false
      store.dispatch("news/suppressNewsModal")
    }

    onMounted(() => {
      if (context.root.$route.query.fromAuth) {
        isDialogOpen.value = true
      } else {
        isDialogOpen.value = false
      }
    })

    // --- Фильтры списка заказов: период визита и количество человек ---
    const upcomingList = computed(() => store.getters["upcoming/getUpcomingList"])
    const dateFrom = ref(null)
    const dateTo = ref(null)
    const dateFromMenu = ref(false)
    const dateToMenu = ref(false)
    const peopleFrom = ref("")
    const peopleTo = ref("")

    const datePickerLocale = computed(() => {
      const locale = localStorage.getItem("locale") || "ru"
      const map = {
        ru: "ru-RU", en: "en-US", zh: "zh-CN", vi: "vi-VN", fa: "fa-IR",
      }

      return map[locale] || "ru-RU"
    })

    // 'YYYY-MM-DD' -> 'DD.MM.YYYY' для поля выбора даты.
    const formatDay = value => {
      if (!value) return ""
      const [year, month, day] = value.split("-")

      return `${day}.${month}.${year}`
    }

    const toNumber = value => {
      if (value === "" || value === null || value === undefined) return null
      const parsed = Number(value)

      return Number.isNaN(parsed) ? null : parsed
    }

    // Кол-во человек считаем тем же способом, что и карточка заказа, чтобы
    // фильтр совпадал с цифрой на экране. Если посчитать не удалось (кривые
    // данные из офиса), заявку не прячем — лучше показать, чем потерять.
    const peopleOf = request => {
      try {
        const total = Number(getQtyTotal(request))

        return Number.isNaN(total) ? null : total
      } catch (error) {
        return null
      }
    }

    // Пустым считаем и "", и «ничего»: крестик очистки у полей Vuetify ставит
    // именно «ничего», и сравнение только с пустой строкой оставляло фильтр
    // «включённым» — висел счётчик и не возвращалась реклама.
    const isSet = value => value !== "" && value !== null && value !== undefined

    // Фильтр по группе: '' — выключен, 'ALL' — все групповые заявки, иначе ключ
    // конкретной группы (клик по метке «ГРУППОВАЯ»).
    // Оценка кабинета. Метку ставит форма заявки после успешной отправки;
    // здесь спрашиваем сервер, оставлял ли этот клиент отзыв раньше, и только
    // тогда показываем окно. Метку снимаем сразу — второй раз за тот же заход
    // предлагать не надо.
    const showFeedback = ref(false)

    // /upcoming?feedback=1 — открыть окно принудительно, чтобы посмотреть, как
    // оно выглядит, не подавая заявку. Повторный отзыв всё равно не запишется:
    // сервер держит один отзыв на логин.
    if (context.root.$route.query.feedback === "1") {
      showFeedback.value = true
    } else if (sessionStorage.getItem("askFeedback") === "1") {
      sessionStorage.removeItem("askFeedback")
      store.dispatch("feedback/fetchState").then(submitted => {
        showFeedback.value = !submitted
      })
    }

    const activeGroupKey = ref("")

    // Галочка «Только групповые» = режим 'ALL'.
    const groupOnly = computed({
      get: () => activeGroupKey.value === "ALL",
      set: v => { activeGroupKey.value = v ? "ALL" : "" },
    })

    // Клик по метке группы: та же группа — снимаем фильтр, иначе выделяем её.
    const onGroupClick = key => {
      activeGroupKey.value = activeGroupKey.value === key ? "" : (key || "ALL")
    }

    const hasFilters = computed(() => !!(dateFrom.value || dateTo.value
      || isSet(peopleFrom.value) || isSet(peopleTo.value) || activeGroupKey.value))

    const resetFilters = () => {
      dateFrom.value = null
      dateTo.value = null
      peopleFrom.value = ""
      peopleTo.value = ""
      activeGroupKey.value = ""
    }

    const filteredRequests = computed(() => {
      let list = upcomingList.value || []

      // Дата визита приходит строкой 'ГГГГ-ММ-ДД' — сравниваем строками,
      // без new Date, чтобы не ловить сдвиг часового пояса.
      if (dateFrom.value || dateTo.value) {
        list = list.filter(request => {
          const day = request.data && request.data.pass_date
          if (!day) return false
          if (dateFrom.value && day < dateFrom.value) return false
          if (dateTo.value && day > dateTo.value) return false

          return true
        })
      }

      const min = toNumber(peopleFrom.value)
      const max = toNumber(peopleTo.value)
      if (min !== null || max !== null) {
        list = list.filter(request => {
          const people = peopleOf(request)
          if (people === null) return true
          if (min !== null && people < min) return false
          if (max !== null && people > max) return false

          return true
        })
      }

      // Группы: 'ALL' — все групповые; иначе только заявки той же группы.
      if (activeGroupKey.value === "ALL") {
        list = list.filter(request => isGroupNotes(request.data && request.data.notes))
      } else if (activeGroupKey.value) {
        list = list.filter(request => isGroupNotes(request.data && request.data.notes)
          && groupKeyOf(request.data) === activeGroupKey.value)
      }

      return list
    })

    return {
      fetchNotification,
      loginNotification,
      fetchUpcoming,
      upcomingList,
      filteredRequests,
      dateFrom,
      dateTo,
      dateFromMenu,
      dateToMenu,
      peopleFrom,
      peopleTo,
      showFeedback,
      activeGroupKey,
      groupOnly,
      onGroupClick,
      datePickerLocale,
      formatDay,
      hasFilters,
      resetFilters,
      obtainingNotice: computed(() => {
        const museums = list => list.map(item => item.museum).join(", ")
        const ready = store.getters["licenses/getObtainingReady"]
        if (ready.length) {
          return context.root.$t("Появилась дата обучения: {museums}. Можно выбрать дату и оплатить.", { museums: museums(ready) })
        }
        const chooseDate = store.getters["licenses/getObtainingChooseDate"]
        if (chooseDate.length) {
          return context.root.$t("Обучение оплачено, выберите дату: {museums}.", { museums: museums(chooseDate) })
        }

        return ""
      }),
      museumObjectsInfo: computed(() => store.getters["upcoming/getMuseumObjectsInfo"]),
      upcomingRequestIsSuccess: computed(() => store.getters["upcoming/getRequestStatus"]),
      adsList: computed(() => store.getters["ads/getAds"]),
      combinedList() {
        // Объявления раньше вставлялись ПО ПОЗИЦИЯМ между заявками и рвали
        // список заказов посередине — на это и пожаловался клиент. Теперь они
        // идут перед списком, а позиция из админки задаёт только порядок между
        // самими объявлениями. При активных фильтрах объявления не показываем:
        // человек в этот момент ищет конкретную заявку.
        if (this.hasFilters) return [...this.filteredRequests]

        const ads = [...this.adsList].sort(
          (first, second) => Number(first.position) - Number(second.position),
        )

        return [...ads, ...this.filteredRequests]
      },
      isDialogOpen,
      closeDialog,
      isNewsModalOpen,
      latestNews,
      closeNewsModal,
      dismissNewsModal,
      replaceBreak,
      getFormatedLocale,
    }
  },
}
</script>

<style lang="scss" scoped></style>
